module.exports = __webpack_public_path__ + "img/checkYourEmailIMG.57c3d130.png";